module.exports = __webpack_public_path__ + "static/media/edit_white_24dp.faad2f04.svg";